/* eslint-disable @typescript-eslint/no-unused-vars */
import { useTranslation } from "react-i18next";
import { CallIcon, CloseBtn, Delete, GroupClose, LinePattern, LocationIcon, MailIcon, ProfileSuccessIcon, Warn } from "../svg/AllSvg";
import PrimaryInput from "../form/PrimaryInput";
import { useFormik } from "formik";
import * as yup from "yup";
import { useEffect, useState } from "react";
import PrimaryTextarea from "../form/PrimaryTextarea";
import SecondaryBtn from "../form/SecondaryBtn";
import logo from "../../../assets/images/LoaderLogo.png"
import darkLogo from "../../../assets/images/DarkLoaderLogo.png"
import { useSelector } from "react-redux";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { Link } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import Captcha from "../form/Captcha";
import { numberOnPaste } from "../../../shared/utils/numberOnPaste";
import { errors } from "../../../shared/utils/errors";
import { Bounce, toast, ToastContainer } from "react-toastify";

const ContactUsForm = () => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const { t } = useTranslation('common');
    const user: any = useSelector((state: any) => state.auth.user);
    const [captchaValue, setCaptchaValue] = useState<string>("")
    const [captchaError, setCaptchaError] = useState<string>("")
    const [captchaExpirationTime, setCaptchaExpirationTime] = useState(Date.now() + (5 * 60 * 1000));
    const [captchaInput, setCaptchaInput] = useState("");
    const [submit, setSubmit] = useState<boolean>(false);
    const [files, setFiles] = useState<any>([]);
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [disable, setDisable] = useState<boolean>(false);
    const [modalStatus, setModalStatus] = useState<boolean>(false);
    const [err, setErr] = useState<any>("");

    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            first_name: !!user?.first_name ? user?.first_name : '',
            last_name: !!user?.last_name ? user?.last_name : '',
            email: !!user?.email ? user?.email : '',
            phone: !!user?.phone ? user?.phone : '',
            subject: '',
            message: ''
        },
        validationSchema: yup.object().shape({
            first_name: yup.string().required(t("auth.form.validation.first_name")),
            last_name: yup.string().required(t("auth.form.validation.last_name")),
            email: yup.string().email(t("auth.form.validation.wrong_email")).required(t("auth.form.validation.email")),
            phone: yup.number().test('len', t("contact_us.form.wrong_contact_number_err"), (val: any) => val && val.toString().length === 10).required(t("contact_us.form.contact_number_err")),
            message: yup.string().required(t("contact_us.form.message_err")),
            subject: yup.string().required(t("contact_us.form.subject_err")),
        }),
        onSubmit: async (values: any, { resetForm }: any) => {
            //submit
            if (!!!captchaValue) {
                setCaptchaError(t("auth.form.validation.captcha"))
                return;
            }

            if (captchaInput !== captchaValue) {
                setCaptchaError(t("auth.form.validation.match_captcha"));
                return;
            }

            if (!!!captchaValue) {
                setCaptchaError(t("auth.form.validation.captcha"))
                return;
            }

            if (captchaInput !== captchaValue) {
                setCaptchaError(t("auth.form.validation.match_captcha"));
                return;
            }

            try {
                setSubmit(true)

                const formData = new FormData();
                formData.append("subject", values?.subject);
                formData.append("first_name", values?.first_name);
                formData.append("contact_number", values?.phone);
                formData.append("last_name", values?.last_name);
                formData.append("email", values?.email);
                formData.append("message", values?.message);
                files?.length > 0 && formData.append("attachments", files?.[0]);

                const res: any = await useAxios.post(url?.contact_us, formData);

                if (res && res?.status === 201) {
                    setModalStatus(true)
                    resetForm({ values: '' });
                    setSubmit(false)
                    setCaptchaValue('')
                    setUploadProgress(0)
                    setFiles([])
                    setCaptchaError('')
                    setErr('')
                }
            } catch (error) {
                errors(error)
                setSubmit(false)
                console.error("error while filling contact us form", error);
            }
        }
    });

    const handleSubmit = () => {
        if (!!!captchaValue) {
            setCaptchaError(t("auth.form.validation.captcha"))
            return;
        }

        if (captchaInput !== captchaValue && files?.length === 0) {
            setCaptchaError(t("auth.form.validation.match_captcha"));
            return;
        }

        if (!!!captchaValue) {
            setCaptchaError(t("auth.form.validation.captcha"))
            return;
        }

        if (captchaInput !== captchaValue) {
            setCaptchaError(t("auth.form.validation.match_captcha"));
            return;
        }
    }

    const simulateChunkUpload = (chunk: any) => {
        return new Promise((resolve: any, reject: any) => {
            setTimeout(() => {
                resolve();
            }, 1000);
        });
    };

    const { getRootProps, getInputProps, open } = useDropzone({
        onDrop: (acceptedFiles: any) => {
            setErr("")
            if (!acceptedFiles[0]?.name?.match(/\.(PDF|pdf|Doc|doc|docx|DOCX|png|PNG|jpg|JPG|jpeg|JPEG)$/)) {
                setErr(t("passenger.lost_found.report_form.validation.valid_file"));
                return true;
            }

            if (acceptedFiles[0].size > (5 * 1000 * 1024)) {
                setErr(t("passenger.lost_found.report_form.validation.size_err"));
                return;
            }
            setUploadProgress(0);
            setDisable(true)
            setFiles([acceptedFiles[0]])
            setErr("")

            let uploadFile = acceptedFiles[0];
            if (uploadFile) {
                const chunkSize = 1024 * 1024; // 1MB chunk size
                const totalChunks = Math.ceil(uploadFile.size / chunkSize);
                let currentChunk = 0;

                const uploadNextChunk = () => {
                    const start = currentChunk * chunkSize;
                    const end = Math.min(start + chunkSize, uploadFile.size);
                    const chunk = uploadFile.slice(start, end);

                    simulateChunkUpload(chunk)
                        .then(() => {
                            currentChunk++;

                            if (currentChunk < totalChunks) {
                                const progress = Math.floor((currentChunk / totalChunks) * 100);
                                setUploadProgress(progress);

                                uploadNextChunk();
                            } else {
                                setUploadProgress(100);
                                setDisable(false)
                            }
                        })
                        .catch((error) => {
                            console.error('Error uploading chunk', error);
                        });
                };

                uploadNextChunk();
            }
        }
    });

    const removeFile = (idx: number) => {
        let arr: any[] = [];
        for (let i = 0; i < files?.length; i++) {
            const el = files[i];

            if (idx !== i) {
                arr.push(el)
            }
        }

        setFiles(arr)
    };

    useEffect(() => {
        if (modalStatus) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [modalStatus]);

    const thumbs = files?.map((file: any, idx: number) => (
        <div key={idx} className='w-full flex items-center justify-between px-[15px] xlx:px-[19px] border border-[#D7D8DD] dark:border-[#454545] rounded-full dark:bg-bgDark bg-[#F5F5F5] h-[35px] xlx:h-[40px] gap-[15px]'>
            <Link to={!!file?.url ? file?.url : URL.createObjectURL(file)} download={!!file?.url ? file?.url : URL.createObjectURL(file)} target="_blank" className="text-blackDull   dark:text-textBlackDull text-sm leading-snug font-normal truncate hover:underline focus:underline">{file?.name}</Link>

            {(uploadProgress !== 100 && (idx + 1 === files?.length)) ?
                <div className="flex items-center gap-[5px]">
                    <h1 className="text-blackDull dark:text-textBlackDull text-sm leading-snug font-normal">{t("passenger.lost_found.report_form.form.uploading")} {uploadProgress}%</h1>
                    <button aria-label={t("aria_label.delete")} title={t("aria_label.delete")} className="min-w-[25px] h-[25px] flex items-center justify-center rounded-full hover:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] focus:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] hover:bg-white focus:bg-white border border-transparent focus:border-[#D7D8DD] hover:border-[#D7D8DD] hover:dark:border-[#454545] focus:dark:border-[#454545] dark:hover:bg-blackDull dark:focus:bg-blackDull" onClick={() => removeFile(idx)} type="button">
                        <GroupClose />
                    </button>
                </div> :
                <div className="flex items-center gap-[5px] whitespace-nowrap">
                    <div {...getRootProps()} onClick={(e) => e.stopPropagation}>
                        <input {...getInputProps()} />
                        <button type="button" onClick={open} className="text-blackDull  dark:text-textBlackDull text-sm leading-snug font-semibold disabled:opacity-[0.5] disabled:cursor-not-allowed" disabled={disable}> {t("passenger.lost_found.report_form.form.replace")}</button>
                    </div>
                    <div className="border-r h-[16px] border-primary pl-[5px]"></div>
                    <button aria-label={t("aria_label.delete")} title={t("aria_label.delete")} onClick={() => removeFile(idx)} type="button" className="min-w-[25px] h-[25px] flex items-center justify-center rounded-full hover:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] focus:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] hover:bg-white focus:bg-white border border-transparent focus:border-[#D7D8DD] hover:border-[#D7D8DD] hover:dark:border-[#454545] focus:dark:border-[#454545] dark:hover:bg-blackDull dark:focus:bg-blackDull">
                        <Delete />
                    </button>
                </div>
            }
        </div>
    ));

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
            <div className="w-full flex gap-[40px] msm:gap-[30px] xl:gap-[60px] xlx:gap-[90px] pb-[80px] xlx:pb-[100px] xl:px-[30px] xlx:px-[50px] msm:flex-row flex-col">
                <div className="shadow-[0px_14px_64px_rgba(24,39,75,0.04),0px_8px_22px_rgba(24,39,75,0.02)] bg-white dark:bg-bgDarkDull p-[30px] xlx:p-[40px] w-full msm:w-[calc(100%-410px)] xl:w-[calc(100%-490px)] xlx:w-[calc(100%-560px)]">
                    <h4 className="text-primaryText dark:text-white font-bold">{t("contact_us.form.title")}</h4>

                    <div className="py-[19px]">
                        <LinePattern />
                    </div>

                    <form className="flex flex-col gap-[25px] xlx:gap-[30px]" onSubmit={(e: any) => { e.preventDefault(); handleSubmit(); formik?.handleSubmit(); }}>
                        <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                            <div className="flex flex-col gap-[4px]">
                                <PrimaryInput title={`${t("auth.form.field.first_name")}*`} name="first_name" type="text" placeholder={t("auth.form.field.first_name")} value={formik?.values?.first_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                                {formik?.touched?.first_name && formik?.errors?.first_name && <div className="flex gap-[6px] items-start"><Warn />
                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.first_name}</span>
                                </div>}
                            </div>

                            <div className="flex flex-col gap-[4px]">
                                <PrimaryInput title={`${t("auth.form.field.last_name")}*`} name="last_name" type="text" placeholder={t("auth.form.field.last_name")} value={formik?.values?.last_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                                {formik?.touched?.last_name && formik?.errors?.last_name && <div className="flex gap-[6px] items-start"><Warn />
                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.last_name}</span>
                                </div>}
                            </div>
                        </div>

                        <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                            <div className="flex flex-col gap-[4px]">
                                <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("contact_us.form.contact_number")}*</h6>
                                <div className="flex items-center gap-[10px] w-full">
                                    <input className="flex items-center justify-center px-[7px] w-[35px] xlx:w-[40px] h-[35px] xlx:h-[40px] rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] text-blackDull text-sm leading-snug dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull" defaultValue="+91" disabled autoComplete="off" />
                                    <input className="placeholder:text-blackDull w-full rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] h-[35px] xlx:h-[40px] px-[15px] xlx:px-[17px] text-blackDull text-sm leading-snug dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull" type="number" name="phone" placeholder={t("contact_us.form.contact_number")} autoComplete="off" value={formik?.values?.phone} onBlur={formik?.handleBlur} onChange={formik?.handleChange} onFocus={(e: any) => e.target.addEventListener("wheel", function (e: any) { e.preventDefault() }, { passive: false })}
                                        onKeyDown={(e: any) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()} onPaste={(e: any) => numberOnPaste(e)} />
                                </div>
                                {formik?.touched?.phone && formik?.errors?.phone && <div className="flex gap-[6px] items-start"><Warn />
                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.phone}</span>
                                </div>}
                            </div>

                            <div className="flex flex-col gap-[4px]">
                                <PrimaryInput title={`${t("auth.form.field.email")}*`} name="email" type="email" placeholder={t("auth.form.field.email")} value={formik?.values?.email} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                                {formik?.touched?.email && formik?.errors?.email && <div className="flex gap-[6px] items-start"><Warn />
                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.email}</span>
                                </div>}
                            </div>
                        </div>

                        <div className="flex flex-col gap-[4px]">
                            <PrimaryTextarea title={`${t("contact_us.form.subject")}*`} placeholder={t("contact_us.form.start_typing")} name="subject" rows="4" value={formik?.values?.subject} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                            {formik?.touched?.subject && formik?.errors?.subject && <div className="flex gap-[6px] items-start"><Warn />
                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.subject}</span>
                            </div>}
                        </div>

                        <div className="flex flex-col gap-[4px]">
                            <PrimaryTextarea title={`${t("contact_us.form.message")}*`} placeholder={t("contact_us.form.start_typing")} name="message" rows="4" value={formik?.values?.message} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                            {formik?.touched?.message && formik?.errors?.message && <div className="flex gap-[6px] items-start"><Warn />
                                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.message}</span>
                            </div>}
                        </div>

                        <div className="flex flex-col gap-[4px] w-full">
                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("grievance.new_complaint.field.add_attachment")}</h6>

                            {files?.length === 0 && <div className="flex flex-col gap-[4px]">
                                <div className="h-[35px] xlx:h-[40px] w-full rounded-full border border-[#D7D8DD] dark:border-[#454545] dark:bg-bgDark bg-[#F5F5F5] flex items-center justify-between pl-[5px] pr-[18px] xlx:pr-[22px]">
                                    <div {...getRootProps()} onClick={(e) => e.stopPropagation} className={`rounded-full ${(disable || files?.length === 1 || submit) ? "" : "focus:shadow-[0_0_0_3px_#059db25e] hover:shadow-[0_0_0_3px_#059db25e]"}`}>
                                        <input {...getInputProps()} />
                                        <button type="button" tabIndex={-1} onClick={open} className="h-[25px] xlx:h-[30px] flex items-center justify-center w-fit px-[15px] xlx:px-[19px] text-white font-bold text-sm !leading-tight rounded-full bg-primary disabled:opacity-[0.5] disabled:cursor-not-allowed" disabled={disable || files?.length === 1 || submit}> {t("passenger.lost_found.report_form.form.upload_file")}</button>
                                    </div>

                                    <h6 className="text-blackDull dark:text-textBlackDull font-normal !leading-tight">{t("grievance.new_complaint.field.type")} <span className="text-primaryText dark:text-white font-semibold !leading-tight"> | {t("passenger.lost_found.report_form.form.size")}</span></h6>
                                </div>
                                {!!err && <div className="flex gap-[6px] mt-[4px]"><Warn />
                                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{err}</span>
                                </div>}
                            </div>}
                            {files?.length > 0 && <aside className='w-full flex flex-col gap-[12px]'>{thumbs}</aside>}
                        </div>

                        <Captcha captchaValue={captchaValue} setCaptchaValue={setCaptchaValue} captchaError={captchaError} setCaptchaError={setCaptchaError} captchaExpirationTime={captchaExpirationTime} setCaptchaExpirationTime={setCaptchaExpirationTime} captchaInput={captchaInput} setCaptchaInput={setCaptchaInput} />

                        <div className="flex w-full items-end justify-end">
                            <SecondaryBtn title={t("contact_us.form.submit")} onClick={() => { handleSubmit(); formik?.handleSubmit(); }} css="w-fit px-[50px] xlx:px-[70px] flex items-center justify-center !rounded-[6px] font-bold" disabled={submit} />
                        </div>

                    </form>

                </div>

                <div className="w-full msm:w-[380px] xl:w-[430px] xlx:w-[470px] flex flex-col gap-[20px] xlx:gap-[25px] msm:pt-[50px] xlx:pt-[80px]">
                    <img src={theme === "dark" ? darkLogo : logo} alt="logo" className="w-[50px] h-[60px]" />
                    <LinePattern />
                    <div className="flex xsm:items-center gap-[15px] msm:gap-[30px] xlx:gap-[45px] xsm:flex-row flex-col">
                        {/* <div className="flex  flex-col gap-[10px]">
                            <h3 className="text-secPurple font-bold">{t("contact_us.content.contact_us")}</h3>
                            <div className="flex items-center gap-[8px] xlx:gap-[10px]">
                                <CallIcon />
                                <h4 className="text-blackDark dark:text-textBlackDark font-semibold"><a href="tel:1800220221" className="focus:underline hover:underline">1800220221</a></h4>
                            </div>
                        </div> */}

                        <div className="flex  flex-col gap-[10px]">
                            <h3 className="text-secRed font-bold">{t("contact_us.content.drop_mail")}</h3>
                            <div className="flex items-center gap-[8px] xlx:gap-[10px]">
                                <MailIcon />
                                <h4 className="text-blackDark dark:text-textBlackDark font-semibold"><a href="mailto:contact@mmrcl.com" className="focus:underline hover:underline">contact@mmrcl.com</a></h4>
                            </div>
                        </div>
                    </div>

                    <LinePattern />

                    {/* <div className="flex  flex-col gap-[10px]">
                        <h4 className="text-blackDark dark:text-textBlackDark font-bold">{t("contact_us.content.o_address.title")}</h4>
                        <div className="flex gap-[8px] xlx:gap-[10px]">
                            <div className="xlx:pt-[3px]">
                                <LocationIcon />
                            </div>
                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("contact_us.content.o_address.add")}</h6>
                        </div>
                    </div> */}

                    <div className="flex  flex-col gap-[10px]">
                        <h4 className="text-blackDark dark:text-textBlackDark font-bold">{t("contact_us.content.r_address.title")}</h4>
                        <div className="flex gap-[8px] xlx:gap-[10px]">
                            <div className="xlx:pt-[3px]">
                                <LocationIcon />
                            </div>
                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("contact_us.content.r_address.add")}</h6>
                        </div>
                    </div>
                </div>
            </div>

            {/* Success Modal */}
            {modalStatus &&
                <div className="fixed inset-0 z-[34] overflow-y-hidden top-0 ">
                    <div
                        className="fixed inset-0 w-full h-full bg-[rgba(171,171,171,0.70)] backdrop-blur-[10px]" onClick={() => setModalStatus(false)}
                    ></div>
                    <div className="flex justify-center items-center min-h-screen">
                        <div className="relative m-[15px] mm:mx-auto dark:bg-bgDarkDull bg-white rounded-[10px] w-full md:w-[600px] xlx:w-[713px] h-[450px] xlx:h-[528px] shadow-[0px_8px_22px_-6px_rgba(24,39,75,0.12),0px_14px_64px_-4px_rgba(24,39,75,0.12))]">
                            <div className="absolute top-[18px] right-[22px]">
                                <button type="button" aria-label={t("aria_label.close")} title={t("aria_label.close")} className="rounded-full focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] min-w-[23px] h-[23px] flex items-center justify-center bg-[#e4e4e4] dark:bg-[#4c4e5e5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" autoFocus={true} onClick={() => setModalStatus(false)}>
                                    <CloseBtn />
                                </button>
                            </div>

                            <div className="w-full h-full flex flex-col items-center justify-center px-[22px]">
                                <ProfileSuccessIcon />
                                <h3 className="text-primaryText dark:text-white font-bold mt-[20px] xlx:mt-[30px] text-center">{t("contact_us.success.title")}</h3>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-center mt-[15px] xlx:mt-[20px]">{t("contact_us.success.desc")}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default ContactUsForm;